import { useState } from "react";
import KeikkaOtsikkoInput from "./KeikkaOtsikkoInput";
import KeikkaOtsikkoLabel from "./KeikkaOtsikkoLabel";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import MyDivider from "src/components/layout/MyDivider";

export default function KeikkaOtsikkoLayout() {
  const { keikkaData } = useKeikkaData();
  const allowEdit = keikkaData.auth.originalEdit;
  const [isEditing, setIsEditing] = useState(false);

  const onEditClick = () => allowEdit && setIsEditing(true);
  const onEditEnd = () => setIsEditing(false);

  return (
    <div className={keikkaData.keikkaOtsikko ? "" : "noPrint"}>
      <MyDivider />
      {isEditing ? (
        <KeikkaOtsikkoInput onEditEnd={onEditEnd} />
      ) : (
        <KeikkaOtsikkoLabel onEditClick={onEditClick} />
      )}
    </div>
  );
}
